import contractAbi from "../abi/CourseContractAbi.json"

class CourseContract {
    constructor(web3, address) {
        this.web3 = web3
        this.contract = new this.web3.eth.Contract(contractAbi, address)
        this.address = address
    }

    async approve(amount) {
        const accounts = await this.web3.eth.getAccounts()
        return await this.contract.methods.approve(this.address, amount).send({ from: accounts[0] })
    }

    async hasPurchased() {
        const accounts = await this.web3.eth.getAccounts()
        return await this.contract.methods.hasPurchased(accounts[0], "influencercourse").call()
    }

    async payProduct() {
        const accounts = await this.web3.eth.getAccounts()
        return await this.contract.methods.payProduct("influencercourse").send({ from: accounts[0] })
    }
}

export default CourseContract
